import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { usePendingUser } from "../contexts/PendingUserContext";
import routing from "../routing";

function RootRedirect() {
  const { user, loading } = useAuth();
  const { termsAccepted } = usePendingUser();

  // show nothing while checking auth
  if (loading) {
    return null;
  }

  // if authenticated AND terms accepted, go to home
  if (user && termsAccepted) {
    return <Navigate to={routing.home.path} replace />;
  }

  // otherwise, go to login
  return <Navigate to={routing.login.path} replace />;
}

export default RootRedirect;